import { useEffect } from 'react';

import EventBridge, { EventCallback, EventTypes } from '/lib/event-bridge';

type EventBridgeHook = <T extends keyof EventTypes>(
  eventType?: T,
  callback?: EventCallback<T>
) => EventCallback<T>;

/**
 * Registers a component or hook with the [EventBridge](../lib/event-bridge.ts).
 * Use this hook to emit inter-feature events.
 */
const useEventBridge: EventBridgeHook = (eventType?, callback?) => {
  useEffect(() => {
    EventBridge.subscribe(eventType, callback);

    return () => {
      EventBridge.unsubscribe(eventType, callback);
    };
  }, [eventType, callback]);

  const emitEvent = (data: EventTypes[keyof EventTypes]) => {
    EventBridge.emit(eventType, data as EventTypes[typeof eventType]);
  };

  return emitEvent;
};

export default useEventBridge;
